module.exports = __webpack_public_path__ + "img/IMG_6094.d499d31e.jpg";